module.exports = __webpack_public_path__ + "img/shape_circle--yellow.ab4026d.png";